import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { actions as salesIntelligenceActions } from 'state/salesIntelligence';

import RecurringOrderSuggestionsModal from 'components/RecurringOrderSuggestionsDiscardReasonsModal/component';

const enhance = compose(
  withTranslation('RecurringOrderSuggestions'),
  connect(() => ({}), {
    sendRecurringOrderSuggestionDiscardReason:
      salesIntelligenceActions.dismissRecurringOrderSuggestion,
  }),
  withHandlers(() => ({
    sendRecurringOrderSuggestionDiscardReason:
      ({ sendRecurringOrderSuggestionDiscardReason }) =>
      (reason) => {
        sendRecurringOrderSuggestionDiscardReason({ reason });
      },
  }))
);

export default enhance(RecurringOrderSuggestionsModal);
